import React from "react";

import clsx from "clsx";

import { PageProgressBarComponent } from "@app/core/page-progress-bar";
import { PlatformAlert } from "@app/core/platform-alert";
import { PlatformDTO } from "@app/bf-api";

import styles from "./filter-bar-wrapper.module.scss";

type FilterBarWrapperProps = {
  children?: React.ReactNode;
  mainDivRef: React.RefObject<HTMLDivElement>;
  filterBarRef: (element: HTMLDivElement | null) => void;
  isSticky: boolean;
  totalHeight: number;
  platform?: PlatformDTO;
};

const FilterBarWrapper: React.FC<FilterBarWrapperProps> = ({
  mainDivRef,
  filterBarRef,
  isSticky,
  totalHeight,
  platform,
  children
}) => {
  return (
    <div ref={mainDivRef}>
      <div ref={filterBarRef}>
        <div className={clsx(styles.filterBar, isSticky && styles.sticky)}>
          {children}
          {isSticky && <PageProgressBarComponent height={totalHeight} mainDivRef={mainDivRef} />}
        </div>
      </div>
      <PlatformAlert platform={platform} />
    </div>
  );
};

export { FilterBarWrapper };
